import { type YatPageItemNFTResponse } from '@app/client/common/structs/yatPage/yat-page-items';

export enum ContentType {
    NFT = 'Nft',
    LINK = 'Link',
    YAT = 'Yat',
}

type Currency = 'eth';

export interface NFTFloorPrice {
    symbol: Currency;
    value: number;
}

export type NFTContent = YatPageItemNFTResponse & {
    // TODO: There is also `name` can we use that instead?.
    title?: string;
    // TODO: There is also `floor_price`?
    floorPrice: NFTFloorPrice;
    fallbackAssetUrl?: string;
};

export interface LinkContent {
    url: string;
    image?: string;
    caption?: string;
    title?: string;
    description?: string;
}

export interface YatContent {
    emojiId: string;
    // TODO: Add other data
}

interface ItemCategory {
    category: string;
    order: number;
}

export enum ItemSize {
    SMALL = 'Small',
    LARGE = 'Large',
    AUTO = 'Auto',
}

export interface LayoutItem {
    isDraggable: boolean;
    moved: boolean;
    static: boolean;
}

export type ContentItemType = NFTContent | LinkContent | YatContent;

export interface ContentItem<T = ContentItemType> {
    id: string;
    order: number;
    draftOrder: number;
    editing: boolean;
    type: ContentType;
    categories: ItemCategory[];
    collection_id?: string | null;
    content?: T;
    hasPersisted?: boolean;
    collapsed?: boolean;
    isURLInvalid?: boolean;
    published?: boolean;
}
